module.exports = __webpack_public_path__ + "img/MenuIcon.a666d20c.svg";